<template>
  <div class="lineChartStatistics">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <div class="custom-date">
            <div
              class="date-btn1"
              @click="onShowEmit('lineChartStatisticsCity')"
            >
              <span v-if="searchForm.CityName">{{ searchForm.CityName }}</span>
              <span v-else>{{ $t.lineChartStatistics.cityName }}</span>
            </div>
            <div class="date-btn2" @click="showYearDate">
              <span v-if="searchForm.Year"
                >{{ searchForm.Year }} {{ $t.meta.year }}</span
              >
              <span v-else>{{ $t.lineChartStatistics.year }}</span>
            </div>
            <van-button size="small" type="info" @click="onSearch">{{
              $t.meta.search
            }}</van-button>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-form>
      <ve-line :data="chartData" :settings="chartSettings"></ve-line>

      <div class="lineChartStatistics-radio">
        <div class="radio-label">
          {{ $t.lineChartStatistics.currency }}：{{ settlementCurrency }}
        </div>
        <van-radio-group
          direction="horizontal"
          v-model="searchForm.Type"
          @change="radioChange($event, true, false)"
        >
          <van-radio :name="1">{{ $t.meta.wbType1 }}</van-radio>
          <van-radio :name="2">{{ $t.meta.wbType2 }}</van-radio>
          <van-radio :name="3">{{ $t.meta.wbType3 }}</van-radio>
          <van-radio :name="4">{{ $t.meta.wbType4 }}</van-radio>
          <van-radio :name="5">{{ $t.meta.wbType5 }}</van-radio>
          <van-radio :name="6">20'</van-radio>
          <van-radio :name="7">40'</van-radio>
          <van-radio :name="8">40HQ</van-radio>
          <van-radio :name="9">45'</van-radio>
        </van-radio-group>
      </div>
    </van-form>

    <van-list class="list" :finished-text="$t.meta.noMore">
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="list-item">
          {{ $t.lineChartStatistics.month }}：{{ item.Month }}
        </div>
        <div class="list-item">
          {{ $t.lineChartStatistics.jobs }}：{{ item.TotalVotes }}
        </div>
        <div class="list-item">
          {{ $t.lineChartStatistics.totalValue }}：{{ item.TotalVolume }}
        </div>
        <div class="list-item">
          {{ $t.lineChartStatistics.totalWeight }}：{{ item.TotalWeight }}
        </div>
        <div class="list-item">
          {{ $t.lineChartStatistics.airPrice }}：{{
            item.AirFreightAverageUnitPrice
          }}
        </div>
        <div class="list-item">20'：{{ item.Degrees20 }}</div>
        <div class="list-item">
          {{ $t.lineChartStatistics.price20 }}：{{
            item.Degrees20AverageUnitPrice
          }}
        </div>
        <div class="list-item">40'：{{ item.Degrees40 }}</div>
        <div class="list-item">
          {{ $t.lineChartStatistics.price40 }}：{{
            item.Degrees40AverageUnitPrice
          }}
        </div>
        <div class="list-item">40'HQ：{{ item.Degrees40HQ }}</div>
        <div class="list-item">
          {{ $t.lineChartStatistics.price40HQ }}：{{
            item.Degrees40HQAverageUnitPrice
          }}
        </div>
        <div class="list-item">Others：{{ item.Others }}</div>
        <div class="list-item">
          {{ $t.lineChartStatistics.priceOther }}：{{
            item.OthersAverageUnitPrice
          }}
        </div>
      </div>
    </van-list>

    <van-popup v-model="showYearPicker" position="bottom">
      <van-datetime-picker
        type="year-month"
        :title="$t.lineChartStatistics.selectYear"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showYearPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <option-list
      event="lineChartStatisticsCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Form,
  Field,
  Button,
  Uploader,
  Icon,
  Row,
  Col,
  Popup,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

Vue.use(List)
  .use(Form)
  .use(Field)
  .use(Button)
  .use(Uploader)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "lineChartStatistics",
  components: {
    OptionList,
  },
  data() {
    return {
      searchForm: {
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        Type: 1,
        Year: "",
        CityName: "",
        CityId: null,
      },
      settlementCurrency: "",
      tableData: [],
      cityList: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //日期
      selectDate: new Date(),
      currentDate: "",
      chartData: null,
      showYearPicker: false,
      chartSettings: {
        yAxisType: ["KMB", "percent"],
        labelMap: {
          cost: this.$t.lineChartStatistics.line1,
          selling: this.$t.lineChartStatistics.line2,
          sales: this.$t.lineChartStatistics.line3,
        },
      },
    };
  },
  created() {
    this.initChartData();
    this.defaultDate();
    const { CityId, SelectType } = this.$route.query;
    if (SelectType) {
      this.searchForm.Type = SelectType;
      this.searchForm.CityId = CityId;
      this.radioChange(this.searchForm.Type, false, true);
    } else {
      this.radioChange(1, true, false);
    }
  },
  methods: {
    initChartData() {
      this.chartData = {
        columns: ["type", "cost", "selling", "sales"],
        rows: [],
      };
    },
    radioChange(value, isDefault = false, isDetail = false) {
      this.getCityList(value).then((success) => {
        if (success) {
          if (isDefault) {
            this.onSelectCity(this.cityList[0]);
          }
          if (isDetail) {
            var city = this.cityList.find(
              (p) => p.value == this.searchForm.CityId
            );
            if (city) {
              this.searchForm.CityName = city.text;
            }
          }
          this.cargoDistributionStatistics();
        }
      });
    },
    onSearch() {
      this.initChartData();
      this.radioChange(this.searchForm.Type, false, false);
    },
    showYearDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showYearPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        return year;
      };
      this.searchForm.Year = formatDate(date);
      this.showYearPicker = false;
    },
    defaultDate() {
      let date = new Date();
      this.searchForm.Year = date.getFullYear().toString();
    },
    cargoDistributionStatistics() {
      this.$commonMethod.showLoading();
      var param = this.searchForm;
      this.$api.dataSummary
        .cargoDistributionStatistics(param)
        .then((res) => {
          var data = res.data;
          this.settlementCurrency = data.SettlementCurrency;
          var rows = [];
          for (var item of data.StatisticsList) {
            rows.push({
              type: item.Month + this.$t.meta.month,
              cost: item.CostPriceLine,
              selling: item.SellingPriceLine,
              sales: item.Sales,
            });
          }
          this.chartData.rows = rows;
          this.tableData = data.DetailsList;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSelectCity(item) {
      this.searchForm.CityName = item.text;
      this.searchForm.CityId = item.value;
    },
    getCityList(type) {
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList({
            type: type == 1 || type == 3 || type == 5 ? 1 : 2,
          })
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.City_cn + "," + item.City_en,
                value: item.Id,
              };
              result.push(data);
            });
            this.cityList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.lineChartStatistics {
  ::v-deep .van-popup {
    .van-picker__columns {
      .van-picker-column:nth-of-type(2) {
        display: none !important;
      }
    }
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          .van-cell {
            padding: 5px 8px 5px 0;
          }
        }
        .van-cell {
          padding: 10px 0px 10px 20px;
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
            overflow: hidden;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
            overflow: hidden;
          }
          .van-button {
            vertical-align: middle;
            width: 18%;
            .van-button__text {
              font-size: 14px !important;
            }
          }
        }
      }
    }
  }
  .van-form {
    .ve-line {
      padding: 20px 0px;
    }
    .lineChartStatistics-radio {
      padding-top: 0px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #ebedf0;
      .radio-label {
        color: #000;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
      }
      .van-radio {
        margin-bottom: 10px;
        font-size: 12px;
        ::v-deep .van-radio__label {
          color: #646566;
        }
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
        width: 50%;
        display: inline-block;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        padding-bottom: 10px;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
